module.exports = __webpack_public_path__ + "static/sport/swiper-3.a403752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/swiper-3.png
// module id = R9ss
// module chunks = 0